// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2QXDC","imageUploader":"EGiftCard_imageUploader__2votu"};